<template>
  <vuescroll>
    <div id="content" class="absolute table w-full h-full -mt-16 lg:mt-0">
      <div class="table-cell align-middle bg-top bg-no-repeat bg-cover">
        <div class="text-6xl text-center">
          <p class="font-black tracking-widest uppercase">I love Coding?</p>
          <div class="text-2xl uppercase">
            Soy
            <VueTyper
              :text="['Desarrollador BackEnd', 'Intento de FrontEnd']"
              :repeat="Infinity"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="200"
              :type-delay="100"
              :pre-erase-delay="2000"
              :erase-delay="0"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              class="uppercase bg-tertiary text-background"
            />
          </div>
        </div>
      </div>
    </div>
  </vuescroll>
</template>

<script>
import vuescroll from "vuescroll";
import { VueTyper } from "vue-typer";

export default {
  name: "Content",
  components: {
    VueTyper,
    vuescroll

  }
};
</script>
